var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-card"},[_c('h3',[_vm._v("Something Went Wrong!")]),_c('p',[_vm._v("Please check your configurations and try again.")]),_c('p',[_vm._v("If you don't have access, please contact your administrator.")])])])
}]

export { render, staticRenderFns }